import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cn from 'classname';

const isActiveByPathname = path => window.location.pathname.includes(path);

const Switch = ({
	intl,
	places
}) => (
	<div className="main__switch-control">
		{places.map(place => <Link
			to={place.name}
			key={place.name}
			className={cn({
				[place.name]: true,
				'active': isActiveByPathname(place.name)
			})}
		>
			<span className='icon'></span>
			<span>{intl(place.title)}</span>
		</Link>)}
	</div>
);

Switch.propTypes = {
	intl: PropTypes.func,
	places: PropTypes.array
};

export default Switch;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/switch-routes/main.js